import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from './error.service';

@Injectable({
  providedIn: 'root',
})
export class ApiHttpService {
  localbaseUrl: string = 'http://localhost:3000/';
  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) {}

  baseUrl = environment.BASEURL;

  public get(url: string, options?: any): Observable<any> {
    return this.http.get(this.baseUrl + url, options).pipe(
      catchError((err) => {
        this.errorService.handleError(err);
        throw err;
      }),
    );
  }
  public getJson(url: string, options?: any): Observable<any> {
    return this.http.get<any>(this.localbaseUrl + url, options);
  }

  public post(url: string, data?: any, options?: any): Observable<any> {
    return this.http.post(this.baseUrl + url, data, options).pipe(
      catchError((err) => {
        this.errorService.handleError(err);
        throw err;
      }),
    );
  }
  public put(url: string, data: any, options?: any): Observable<any> {
    return this.http.put(this.baseUrl + url, data, options).pipe(
      catchError((err) => {
        this.errorService.handleError(err);
        throw err;
      }),
    );
  }
  public delete(url: string, options?: any) {
    return this.http.delete(this.baseUrl + url, options).pipe(
      catchError((err) => {
        this.errorService.handleError(err);
        throw err;
      }),
    );
  }
  errorHandler(error: HttpErrorResponse) {
    return error.message || 'server error.';
  }
}
